import { render, staticRenderFns } from "./UserGroups.vue?vue&type=template&id=1b12ac1a&scoped=true"
import script from "./UserGroups.vue?vue&type=script&lang=js"
export * from "./UserGroups.vue?vue&type=script&lang=js"
import style0 from "./UserGroups.vue?vue&type=style&index=0&id=1b12ac1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b12ac1a",
  null
  
)

export default component.exports